module.exports = __webpack_public_path__ + "static/media/location.b3f05409.svg";